import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestResponse } from '../model/dto/RequestResponse';
import { ReturnConfigStoreDto } from '../model/dto/ReturnConfigStoreDto';

@Injectable()
export class ReturnConfigFacade {
    private _urlBase: string;
    private _httpClient: HttpClient;

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this._urlBase = baseUrl;
        this._httpClient = http;
    }

    GetConfigByStoreId(sapStoreCode:string): Observable<RequestResponse<ReturnConfigStoreDto>> {
        return this._httpClient.get<RequestResponse<ReturnConfigStoreDto>>(this._urlBase + 'api/ReturnConfig/withDto?sapStoreCode='+sapStoreCode);
    }

    SaveReturnConfig(parameters: any): Observable<any> {
        const body = JSON.stringify(parameters);
        return this._httpClient.post(this._urlBase + 'api/ReturnConfig/', body, {
          headers: new HttpHeaders({'Content-Type':  'application/json'})
        });
      }
}
